import Permissions, { usePermissions } from '@app/src/auth/permissions'
import { insertIf } from '@app/src/utils/helpersTs'
import navigationLinks from '@app/src/wf-constants/navigationLinks'
import { useFlags } from 'launchdarkly-react-client-sdk'
import React from 'react'
import { useIntl } from 'react-intl'
import type { MenuWrapperProps } from './LegacyMenuWrapper'
import MenuWrapper from './LegacyMenuWrapper'
import type { NavbarItemProps } from './LegacyNavbarItems'

const SustainabilityReportMenu: React.FC<NavbarItemProps> = ({ closeMenuDrawer }) => {
  const { formatMessage } = useIntl()
  const { insightReport, supplyChainDueDiligenceStatement } = useFlags()
  const { hasPermission } = usePermissions()

  const permission = Permissions.SUSTAINABILITY_REPORT_ACCESS

  const isAllowed = hasPermission(permission)
  if (!isAllowed) return null

  const menuItems: MenuWrapperProps['menuItems'] = [
    ...insertIf(insightReport, {
      title: formatMessage({ id: 'navbar.insightsReport' }),
      link: navigationLinks.insightsReport,
      permission: [permission],
    }),
    ...insertIf(supplyChainDueDiligenceStatement, {
      title: formatMessage({ id: 'navbar.supplyChainDueDiligenceStatement' }),
      link: navigationLinks.supplyChainDueDiligenceStatement,
      permission: [permission],
    }),
  ]

  if (menuItems.length === 0) return null

  return (
    <MenuWrapper
      closeMenuDrawer={closeMenuDrawer}
      menuItems={menuItems}
      title={formatMessage({ id: 'navbar.sustainabilityReport' })}
    />
  )
}

export default SustainabilityReportMenu
